import React, { FC, useState } from 'react';
import { ButtonCont, MenuCont, SelectCont, SelectedItemCont, ExpandIcon } from './Select.styles';
import ExpandArrow from '@/assets/icons/expandIcon.svg?react';

interface ISelect {
  options: string[];
  selectedItem: string;
  onChange: (option: string[]) => void;
}

const Select: FC<ISelect> = ({ options, selectedItem, onChange }) => {
  const [isOpened, setIsOpened] = useState(false);

  const menu = {
    selectable: true,
    defaultSelectedKeys: [`${options.indexOf(selectedItem)}`],
    items: options.map((option: string, index: number) => ({
      label: option,
      key: `${index}`,
      'data-testid': 'select-menu-item',
    })),
    onSelect: ({ selectedKeys }: { selectedKeys: string[] }) => {
      onChange(selectedKeys.map(key => options[parseInt(key)]));
      setIsOpened(false);
    },
  };

  return (
    <SelectCont menu={menu} trigger={['click']} placement="top">
      <ButtonCont onClick={() => setIsOpened(prev => !prev)} data-testid="select-button">
        <SelectedItemCont data-testid="selected-item">{selectedItem}</SelectedItemCont>
        <ExpandIcon id="ExpandIcon" data-testid="expand-icon" isOpened={isOpened}>
          <ExpandArrow />
        </ExpandIcon>
      </ButtonCont>
    </SelectCont>
  );
};

export default Select;
